var map = {
	"./1.jpg": "eKea",
	"./2.jpg": "57CY",
	"./3.jpg": "Vr8m",
	"./4.jpg": "saf7",
	"./5.jpg": "pAkR",
	"./6a.jpg": "nxOZ",
	"./6b.jpg": "tshg",
	"./6c.jpg": "GE54",
	"./6d.jpg": "Oe/Z",
	"./6e.jpg": "sOM+",
	"./7.jpg": "9148",
	"./mapa.png": "Nf/6",
	"./mapa_eng.png": "pr4D",
	"./mapa_esp.png": "n4eH",
	"./mapa_fra.png": "dWFh",
	"./thumb_1.png": "wyaw",
	"./thumb_2.png": "yAZF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9F4u";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art ^\.\/.*$
// module id = 9F4u
// module chunks = 1